export const AUTO_PLACEMENTS = ['auto', 'auto-start', 'auto-end'] as const;
export const ARROW_SIZE = 8;
export const OVERFLOW_PADDING = 4;
export const TRANSITION_DURATION = 100;
